const productCarousels = document.querySelectorAll('.product-carousel');

productCarousels?.forEach(carousel => {

    window.addEventListener('load', () => {
        positionProductCarouselNavs(carousel); 
        window.addEventListener('resize', () => {
            positionProductCarouselNavs(carousel); 
        });
    });

    const carouselConfig = JSON.parse(carousel?.dataset.swiperConfig);
    let productCarousel = new Swiper(carousel, carouselConfig);
})


function positionProductCarouselNavs(carousel) {
    const productCarouselNavs = carousel?.parentNode.nextElementSibling;
    const productCarouselImgHeight = carousel?.querySelectorAll('product-item')[0]?.querySelector('.product-item__image-wrapper')?.getBoundingClientRect().height;
    if (productCarouselNavs) {
        const calculateHeight = productCarouselImgHeight / 2 - productCarouselNavs.getBoundingClientRect().height / 2;
        productCarouselNavs.style.top = calculateHeight + 'px';
        productCarouselNavs.style.visibility = 'visible';
    }
}